
import { useEffect, useState } from 'react';
import './gradebook.css';
import connector from '../../connector/connector';
import utilities from '../../utils/utils';
import Footer from '../../components/footer/footer';
import Header from '../../components/header/header';
import BannerImage from '../../components/bannerImage/bannerImage';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import AdminHeader from '../../components/adminHeader/adminHeader';

moment().format();



const Gradebook = () => {

    const navigate = useNavigate();

    if(!localStorage.getItem('adminTokenTime') || utilities.isdateOlderThan30Minutes(localStorage.getItem('adminTokenTime'))){
        navigate('/admin');
    }

    const [gradebookDisplayList, setGradebookDisplayList] = useState([]);
    const [showIdColumn, setShowIdColumn] = useState(false);
    const [dataCopy, setDataCopy] = useState([]);

    useEffect(() => {
        const fetchGradebookData = async () => {
            // get gradebook data
            let gradeData = await connector.fetchGradebookData();

            // console.log('gradeData', gradeData);
            setGradebookDisplayList(gradeData.sort((a, b) => new Date(b.createdTime) - new Date(a.createdTime)) );
            setDataCopy(gradeData.sort((a, b) => new Date(b.createdTime) - new Date(a.createdTime)));
        };

        fetchGradebookData();
    }, []);

    const changeDateOrder = () => {}

    const goToAssessment = (id) => {
        navigate(`/admin/gradebook/assessment/${id}`)
    }

    const handleSearchInput = (e) => {
        let searchTerm = e.target.value.toLowerCase();
        if(searchTerm === ''){
            setGradebookDisplayList(dataCopy);
            return;
        }
        let filteredList = gradebookDisplayList.filter((entry) => {
            if(entry.fields['Submitted By'] && entry.fields['Submitted By'].toLowerCase().includes(searchTerm)){
                return true;
            }
            if(entry.fields.Assessment && entry.fields.Assessment.toLowerCase().includes(searchTerm)){
                return true;
            }
            return false;
        });
        setGradebookDisplayList(filteredList);
    }

    const filterAll = () => {
        setGradebookDisplayList(dataCopy);
    }

    const filterWeighted = () => {
        setGradebookDisplayList(dataCopy.filter(val => {
           return val.fields['Weighted'] === 'true'
        }))
    }

    const filterUnweighted = () => {
        setGradebookDisplayList(dataCopy.filter(val => {
           return val.fields['Weighted'] === 'false'
        }))
    }

    const filterReviewed = () => {
        setGradebookDisplayList(dataCopy.filter(val => {
           return val.fields['Reviewed'] === 'true'
        }))
    }

    const filterUnreviewed = () => {
        setGradebookDisplayList(dataCopy.filter(val => {
           return val.fields['Reviewed'] === 'false'
        }))
    }

  



    return (
        <>
        <div className='gradebook-wrapper'>
            <AdminHeader></AdminHeader>
            {/* <Header></Header> */}
            <BannerImage text={`Gradebook (${gradebookDisplayList.length})`}></BannerImage>
            {/* <h1>Gradebook<span>{gradebookDisplayList.length}</span></h1> */}
            <div className='admin-list-controls-wrapper'>
                
                    <input type='text' placeholder='Search by Email or Assessment ID' onChange={handleSearchInput} className='admin-search'></input>
                    <ul>
                    <li>
                            <button onClick={filterAll}>All</button>
                        </li>
                        <li>
                            <button onClick={filterReviewed}>Reviewed</button>
                        </li>
                        <li>
                            <button onClick={filterUnreviewed}>Unreviewed</button>
                        </li>
                        <li>
                            <button onClick={filterWeighted}>Counted</button>
                        </li>
                        <li>
                            <button onClick={filterUnweighted}>Uncounted</button>
                        </li>
                    </ul>
                    {/* <label>
                    <input 
                        type="checkbox" 
                        checked={showIdColumn} 
                        onChange={(e) => setShowIdColumn(e.target.checked)} 
                        className='show-id-checkbox'
                    />
                    Show Assessment ID
                </label> */}
                
            </div>
            {/* <div className='gradebook-disclaimer'>
                    <p>Only assessments with at least 10 answered questions are displayed</p>
                </div> */}
            <table className='gradebook-table'>
                <thead>
                    <tr>
                       { showIdColumn && <th>Assessment ID</th> }
                        <th>Date</th>
                        <th>Email</th>
                     
                        <th>Responses</th>
                        {/* <th>Date Completed</th> */}
                        <th>Counted</th>
                        <th>Reviewed</th>
                    </tr>
                </thead>
                <tbody>
                    {gradebookDisplayList.map((entry, index) => (
                        <tr key={index} onClick={() => {goToAssessment(entry.fields.Assessment)}}>
                           {showIdColumn &&  <td>{entry.fields.Assessment}</td>}
                            <td>{`${moment(entry.createdTime).format("MMMM Do YYYY, h:mm:ss A")} (${moment(entry.createdTime).fromNow()})`}</td>
                            <td>{entry.fields['Submitted By']}</td>
                            
                            {/* <td>{entry.fields.responses?.length || 0}%</td> */}
                            <td><progress value={entry.fields.responses?.length || 0} max={33} title={entry.fields.responses?.length} className={entry.fields.responses?.length < 5 ? 'progress-red' : entry.fields.responses?.length < 20 ? 'progress-yellow' : 'progress-green'}></progress></td>
                            {/* <td>{utilities.convertdateTimeToReadable(entry.dateCreated)}</td> */}
                            <td><p className={entry.fields.Weighted === "true" ? 'weighted-pill' : 'empty-pill'}>{entry.fields.Weighted}</p></td>
                            <td><p className={entry.fields.Reviewed === "true" ? 'weighted-pill' : 'empty-pill'}>{entry.fields.Reviewed}</p></td>
                        </tr>
                    ))}
                   
                </tbody>
            </table>
            <div className='display-count-div'>
                <p>{`${gradebookDisplayList.length} ${gradebookDisplayList.length === 1 ? 'assessment' : 'assessments'} shown`}</p>
            </div>
            <Footer></Footer>
        </div>
        </>
    );
}

export default Gradebook;